import { render } from "./district-single.vue?vue&type=template&id=315659ce&scoped=true"
import script from "./district-single.vue?vue&type=script&lang=js"
export * from "./district-single.vue?vue&type=script&lang=js"

import "./district-single.vue?vue&type=style&index=0&id=315659ce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315659ce"]])

export default __exports__